import React from "react";
import PropTypes from "prop-types";

import Close from "core/ReusableIcons/Close";
import Photo from "core/ReusableIcons/Photo";

import {
    CardBulletList,
    CardBulletListTitle,
    CardBulletListTitleIcon,
    CardBulletListTitleContainer
} from "core/Card";
import colors from "core/colors";
import { StyledPhotosSectionCard } from "./styles";

const PhotosSectionCard = ({ editorialUseOnly }) => {
    const Icon = editorialUseOnly ? Photo : Close;
    const titleText = editorialUseOnly
        ? '*Photos marked "Editorial Use Only":'
        : "*Please note for all photos:";
    const bulletList = editorialUseOnly ? (
        <>
            <li>May only be used non-commercially</li>
            <li>Not cleared for promotional use</li>
            <li>Not cleared for use in merchandising</li>
        </>
    ) : (
        <>
            <li>May not resell or use on products</li>
            <li>May not use in advertisements</li>
            <li>No multi-seat use</li>
        </>
    );

    return (
        <StyledPhotosSectionCard bulletList transparent>
            <CardBulletListTitleContainer>
                <CardBulletListTitleIcon>
                    <Icon
                        fillColor={
                            editorialUseOnly ? colors.ultramarine : colors.coral
                        }
                    />
                </CardBulletListTitleIcon>
                <CardBulletListTitle>{titleText}</CardBulletListTitle>
            </CardBulletListTitleContainer>
            <CardBulletList>{bulletList}</CardBulletList>
        </StyledPhotosSectionCard>
    );
};

PhotosSectionCard.propTypes = {
    editorialUseOnly: PropTypes.bool
};

export default PhotosSectionCard;
